const YscEventJudgingConfig = {
  judgingRegistrationTemplates: [68544, 74057],
  teamProjectTemplates: [72044, 72045],
  filterName: 'Ysc Judging Team Projects Filter'
}

const OasEventJudgingConfig = {
  judgingRegistrationTemplates: [100392],
  teamProjectTemplates: [101194, 101199, 101200, 101201, 101202, 101203],
  filterName: 'OAS Judging Team Projects Filter'
}

const DefaultConfig = {
  judgingRegistrationTemplates: [],
  teamProjectTemplates: [],
  filterName: ''
}

export const judgingConfig = function () {
  switch (process.env.APP_NAME.toLowerCase()) {
    case 'ysc':
      return YscEventJudgingConfig
    case 'ohiosci':
      return OasEventJudgingConfig
    default:
      return DefaultConfig
  }
}
